enum Links {
  ComingSoon = 'coming-soon',
}

export const privacyPolicy = [
  {
    id: null,
    label: null,
    content: ``,
  },
  {
    id: Links.ComingSoon,
    label: 'Privacy Policy',
    content: `Coming soon...`,
  },
];
